<template>
  <div v-show="active">
    <UsersTable
      v-if="keepAlive"
      ref="sellerOperation"
      reference="sellerOperationTable"
      :namespace="`users?group_id=${groupSellerOperation}`"
      :groups="groups"
      @delete="$emit('delete', $event)"
      @edit="$emit('edit', $event)"
    />
  </div>
</template>

<script>
import UsersTable from "./UsersTable.vue";

export default {
  name: "SellerOperation",
  props: {
    groups: {
      type: Array,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    UsersTable,
  },
  data() {
    return {
      keepAlive: false,
    };
  },
  computed: {
    groupSellerOperation() {
      return this.groups.find((group) => group.name === "Seller-Operation")?.id;
    },
  },
  watch: {
    active(newValue) {
      if (newValue && !this.keepAlive) {
        this.keepAlive = true;
      }
    },
  },
  methods: {
    loadData() {
      this.$refs.sellerOperation?.getData();
    },
  },
};
</script>
